import { el } from 'redom';

import { getRootElAttributes } from './utilities';

import conditionTypes from './condition-types';
import classes from './classes';

import './index.scss';

class ConditionTypeSelector {

  constructor(options) {

    this.selected = options.conditionType || conditionTypes.AND;
    this.onChange = options.onChange;

    this.topConnector = el('.condition-type-selector-top-connector', {
      class: 'condition-type-selector-connector'
    }, [el('.condition-type-selector-connector-line.first'), el('.condition-type-selector-connector-line.second')]);
    this.andButton = null;
    this.orButton = null;
    this.buttonsContainer = null;
    this.bottomConnector = el('.condition-type-selector-bottom-connector', {
      class: 'condition-type-selector-connector'
    }, [el('.condition-type-selector-connector-line.first'), el('.condition-type-selector-connector-line.second')]);

    this.initializeButtons();

    this.el = el('.condition-type-selector-main.small', [this.topConnector, this.buttonsContainer, this.bottomConnector], {
      ...getRootElAttributes(options)
    });

  }

  initializeButtons() {

    this.andButton = el('button.and-type-condition-button', 'AND', {
      class: 'customers-filter-condition-button',
      onclick: this.handleANDButtonClick.bind(this)
    });

    this.orButton = el('button.or-type-condition-button', 'OR', {
      class: 'customers-filter-condition-button',
      onclick: this.handleORButtonClick.bind(this)
    });

    if (this.selected === conditionTypes.AND) {
      this.andButton.classList.add('selected');
    } else {
      this.orButton.classList.add('selected');
    }

    this.buttonsContainer = el('.condition-type-selector-buttons-container', [
      this.andButton,
      this.orButton
    ]);

  }

  handleANDButtonClick(event) {

    event.stopPropagation();

    this.trySelectANDCondition();

    return false;

  }

  handleORButtonClick(event) {

    event.stopPropagation();

    this.trySelectORCondition();

    return false;

  }

  publishSelected() {

    this.andButton.classList.toggle('selected');
    this.orButton.classList.toggle('selected');

    this.onChange(this.selected);

  }

  selectANDCondition() {

    this.selected = conditionTypes.AND;
    this.el.classList.remove(classes.OR);
    this.publishSelected();

  }

  trySelectANDCondition() {

    if (this.selected === conditionTypes.AND) {
      return;
    }

    this.selectANDCondition();

  }

  selectORCondition() {

    this.selected = conditionTypes.OR;
    this.el.classList.add(classes.OR);
    this.publishSelected();

  }

  trySelectORCondition() {

    if (this.selected === conditionTypes.OR) {
      return;
    }

    this.selectORCondition();

  }

}

export default ConditionTypeSelector;